import { Component, Vue } from 'vue-property-decorator';
import { Breadcrumbs } from '../list/types';

@Component
export default class BreadcrumbsMixin extends Vue {
  public breadcrumbs: Breadcrumbs = [
    {
      text: 'Главная',
      to: { path: '/' },
    },
    {
      text: 'Профессии',
      to: { name: 'professions' },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/pages/professions/mixins/breadcrumbs-mixin.ts